import http from './http'
let url = 'AutoAtendimento/'

//Cadastro
export function patchSenha(payload){
    return http.patch(url + 'alterarSenha', payload)
}
export function postTelefone(payload){
    return http.post(url + 'telefoneAutoatendimento', payload)
}
export function postEmail(payload){
    return http.post(url + 'emailAutoatendimento', payload)
}
export function getEmails(){
    return http.get(url + 'emailsAutoatendimento')
}
export function getTelefones(){
    return http.get(url + 'telefonesAutoatendimento')
}
export function getEnderecos(){
    return http.get(url + 'enderecosAutoatendimento')
}
export function getTiposTelefone(){
    return http.get(url + 'tipoTelefones')
}
export function getTiposEndereco(){
    return http.get(url + 'tipoEnderecos')
}
export function postEndereco(payload){
    return http.post(url + 'enderecoAutoatendimento', payload)
}
// Dívida
export function getDividas(payload){
    return http.get(url + 'BuscarDividasInscricao/' + payload)
}
export function getDivida_Parcela(payload){
    return http.get(url + 'ParcelasOriginaisAtivas/' + payload)
}
export function getValoresDevido(payload){
    return http.get(url + 'ValoresDevido/' + payload.chaveDivida + '/' + payload.qtdParcelas + '/' + payload.parcelasOriginais + '/' + payload.valorEntrada + '/' + payload.acordoCartaoCredito + '/' + payload.data)
}
export function getParcelasPagSeguro(params) {
    return http.get(url + `PagSeguro/ParcelasOriginaisAtivas/${params}`)
}
export function postOpcoesAcordoPagSeguro(params,payload){
    return http.post(`${url}PagSeguro/opcoesDeAcordo/${params.chaveDivida}/${params.qtdParcelas}/${params.dataAtual}`,payload)
}
export function postFormalizaAcordoPagSeguro(params, payload){
    return http.post(`${url}PagSeguro/FormalizarAcordo/${params.chaveDivida}/${params.qtdParcelas}/${params.dataAtual}`, payload)
}
export function getOpAcordo(payload){
    return http.get(url + 'OpcoesDeAcordo/' + payload.chaveDivida + '/' + payload.qtdParcelas + '/' + payload.parcelasOriginais + '/' + payload.valorEntrada + '/' + payload.acordoCartaoCredito + '/' + payload.data)
}
export function getOpAcordoPorValor(payload){
    return http.get(url + 'OpcoesDeAcordoporValor/' + payload.chaveDivida + '/' + payload.vrParcelasDesejado + '/' + payload.parcelasOriginais + '/' + payload.valorEntrada + '/' + payload.acordoCartaoCredito + '/' + payload.data)
}
export function postAcordo(payload){
    return http.post(url + 'FormalizarAcordo', payload)
}
// Acordo
export function getNegociacoes(payload) {
    return http.get(url + 'BuscarNegociacoesInscricao/' + payload)
}
export function getDetalheAcordo(payload) {
    return http.get(url + 'detalhesAcordo/' + payload)
}
export function postBaixaAcordoCartao(payload) {
    return http.post(url + 'BaixaAcordoCartao', payload)
}